/* eslint-disable */ 
import React from 'react';
import PropTypes from 'prop-types';

import Carousel from '../../../components/Carousel';
import styles from './SinglePageSpread.module.css';
import { ImageModeContext } from './ImageModeContext';
import { Page } from './Page';

export default class SinglePageSpread extends React.Component {
	static contextType = ImageModeContext;
	state = {
		index: null,
	};
	componentDidMount() {
		let { article, subscribeEvent, onChangePage } = this.context;
		const { pages } = this.props;
		const position = this.getPagePosition(pages, article);
		const totalOfPages = pages.length;
		const currentPage = position.index + 1;
		onChangePage({
			article,
			currentPage,
			totalOfPages,
		});
		subscribeEvent('next-article', this.onNextArticle);
		subscribeEvent('prev-article', this.onPrevArticle);
		this.setState({ index: position.index, frames });
	}

	componentDidUpdate(_, prevState) {
		const { onChangePage, articleMap, onArticleChange } = this.context;
		const { pages } = this.props;
		const { index } = this.state;
		if (prevState.index !== index) {
			const page = pages[index];
			const article = articleMap.get(page.article)
			onChangePage({
				currentPage: page.index + 1,
				article
			});
			onArticleChange(article)
		}
	}

	componentWillUnmount() {
		const { removeEvent } = this.context;
		removeEvent('next-article');
		removeEvent('prev-article');
	}

	onNextArticle = () => {
		const { pages } = this.props;
		const { index } = this.state;
		if (index >= pages.length - 1) {
			return;
		}
		this.setState({
			index: index + 1
		});
	};

	onPrevArticle = () => {
		const { index } = this.state;
		if (index > 0) {
			this.setState({
				index: index - 1
			});
		}
	};

	getPagePosition = (pages, article) => {
		const { articleMap } = this.context;
		const position = {
			index: 0,
			article: null
		}
		for (let i = 0; i < pages.length; i++) {
			const page = pages[i];
			for (const a of page.articles) {
				if (`${a.id}` === `${article.id}`) {
					position.index = i;
					position.article = articleMap.get(page.article);
					return position;
				}
			}
		}

		return position;
	};

	getArticleIndex = (pages) => {
		const { article } = this.context;

		for (let i = 0; i < pages.length; i++) {
			const page = pages[i];
			if (`${page?.article?.id}` === article.id) {
				return i;
			}
		}

		return 0;
	};

	toFrames = (currentIndex, total) => (page, i) => {
		return (
			<SinglePage currentIndex={parseInt(`${currentIndex}`)}
				total={total} page={page} index={i} />
		);
	};

	onChangePage = ({ currentFrameIndex }) => {
		if (
			!!currentFrameIndex.childNodes &&
			!!currentFrameIndex.childNodes.length
		) {
			const index =
				currentFrameIndex.childNodes[0].getAttribute('data-index');

			if (index !== null) {
				this.setState({
					index: parseInt(`${index}`)
				})
			}
		}
	};

	render() {
		const { isArticleSelected } = this.context;
		const { pages } = this.props;
		const { index } = this.state;
		if (!pages.length) {
			return null;
		}
		
		const frames = pages.map(this.toFrames(index, pages.length));
		return (
			<div className={styles['single-page-container']}>
				<Carousel
					scrollDelta={5}
					disableSwipe={isArticleSelected}
					onStartFrameIndex={index}
					onTransitionEnd={this.onChangePage}
					frames={frames}
					loop={false}
				/>
			</div>
		);
	}
}

SinglePageSpread.propTypes = {
	pages: PropTypes.array
};


class SinglePage extends React.Component {
	static contextType = ImageModeContext;
	onSelect = (ArticleID, direction) => {
		const { articleMap, onImageClick } = this.context;
		const article = articleMap.get(ArticleID);
		if (!article) {
			return;
		}
		onImageClick(article, direction)
	};
	getPageComponent = (page, direction) => {
		const { device } = this.context;
		if (!page) {
			return null;
		}

		const { articles, image } = page;
		let article = null;
		let blocks = null;
		if (articles.length === 1) {
			article = articles[0].ArticleID;
		} else {
			blocks = page.articles.reduce((acc, article) => {
				const { ArticleID, blocks } = article;
				acc[ArticleID] = blocks;
				return acc;
			}, {});
		}

		return (
			<Page
				article={article}
				image={image}
				disableDrag={!device.isTouchable}
				onSelect={(article) => {
					this.onSelect(article, direction)
				}}
				blocks={blocks}
			/>
		);
	};
	render() {
		const { index, page, currentIndex, total } = this.props;

		let shouldDisplay = false;

		// First page
		if (index == 0) {
			shouldDisplay = currentIndex === 0 || currentIndex === 1;
		} else if (currentIndex == total - 1) {
			// Last page
			shouldDisplay = index === total - 1 || index === total - 2;
		} else {
			shouldDisplay =
				index === currentIndex ||
				index === currentIndex - 1 ||
				index === currentIndex + 1;
		}

		return (
			<div
				id={`page-${index}`}
				data-index={index}
				className={styles['single-page']}
			>
				{shouldDisplay ? this.getPageComponent(page, 'left') : null}
			</div>
		);
	}
}
SinglePage.propTypes = {
	page: PropTypes.object.isRequired,
	index: PropTypes.number.isRequired,
	total: PropTypes.number,
	currentIndex: PropTypes.number,
};

SinglePage.propTypes = {
	page: PropTypes.object.isRequired,
	index: PropTypes.number.isRequired,
	total: PropTypes.number,
	currentIndex: PropTypes.number,
};
